import i18n from "../../i18n/i18n"

export enum ApplicationStatusType {
    NotSet = 0,
    Pending = 1,
    RequirementsFulfilled = 2,
    Rejected = 3,
    ReadyForCardProduction = 4,
    SentToCardProduction = 5,
    CertificateIssued = 6,
    CertificateExpired = 7,
    RequestedReplacementCancellation = 8,
    RequestedRenewalCancellation = 9,
    RequestedChangeCancellation = 10,
    CertificateRevokedCancellation = 11,
    MarkedAsDeleted = 12,
    CancelledDueToErrorsInApplication = 13,
    CertificateCancelledDueToErrorsOnCertificate = 14
}

// tslint:disable-next-line:no-namespace
export namespace ApplicationStatusType {
	export function displayName(type: ApplicationStatusType) {
		const values: { [index: number]: string } = {
			1: "ENUM_APPLICATIONSTATUSTYPE_PENDING",
			2: "ENUM_APPLICATIONSTATUSTYPE_REQUIREMENTSFULFILLED",
			3: "ENUM_APPLICATIONSTATUSTYPE_REJECTED",
			4: "ENUM_APPLICATIONSTATUSTYPE_READYFORCARDPRODUCTION",
			5: "ENUM_APPLICATIONSTATUSTYPE_SENTTOCARDPRODUCTION",
			6: "ENUM_APPLICATIONSTATUSTYPE_CERTIFICATEISSUED",
			7: "ENUM_APPLICATIONSTATUSTYPE_CERTIFICATEEXPIRED",
			8: "ENUM_APPLICATIONSTATUSTYPE_REQUESTEDREPLACEMENTCANCELLATION",
			9: "ENUM_APPLICATIONSTATUSTYPE_REQUESTEDRENEWALCANCELLATION",
			10: "ENUM_APPLICATIONSTATUSTYPE_REQUESTEDCHANGECANCELLATION",
			11: "ENUM_APPLICATIONSTATUSTYPE_CERTIFICATEREVOKEDCANCELLATION",
			12: "ENUM_APPLICATIONSTATUSTYPE_MARKEDASDELETED",
			13: "ENUM_APPLICATIONSTATUSTYPE_CANCELLEDDUETOERRORSINAPPLICATION",
			14: "ENUM_APPLICATIONSTATUSTYPE_CERTIFICATECANCELLEDDUETOERRORSONCERTIFICATE"
		}

		if (values.hasOwnProperty(type)) {
			return i18n.t(values[type])
		} else {
			return i18n.t(ApplicationStatusType[type])
		}
	}
}
